import { takeLatest, call, put } from "redux-saga/effects";
import {
  SUBMIT_COMPETITOR_PROFILE_V1_REQUEST,
  submitCompetitorProfileV1Success,
  submitCompetitorProfileV1Failure,
} from "../actions/competitorProfileV1Actions";
import { fetchCompetitorProfileV1 } from "../../../services/accIqService";

// Worker Saga
function* handleCompetitorProfileV1Submission(action) {
  try {
    const response = yield call(fetchCompetitorProfileV1, action.payload);
    yield put(submitCompetitorProfileV1Success(response));
  } catch (error) {
    yield put(
      submitCompetitorProfileV1Failure(error?.message || "Something went wrong")
    );
  }
}

// Watcher Saga
export function* watchCompetitorProfileV1Submission() {
  yield takeLatest(
    SUBMIT_COMPETITOR_PROFILE_V1_REQUEST,
    handleCompetitorProfileV1Submission
  );
}
